module.exports = __webpack_public_path__ + "img/upload.b01957ff.png";